
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { UserModel } from 'models/generated/Identity.Api.Models.User';
import { TeamModel } from 'models/generated/Identity.Api.Models.Team';


const _identity_UserControllerHelper = new Map<string, Object>();
_identity_UserControllerHelper.set('GetAllUsers', UserModel);
_identity_UserControllerHelper.set('GetUser', UserModel);
_identity_UserControllerHelper.set('CreateUser', UserModel);
_identity_UserControllerHelper.set('UpdateUser', UserModel);
_identity_UserControllerHelper.set('GetAllTeams', TeamModel);
_identity_UserControllerHelper.set('GetTeam', TeamModel);
_identity_UserControllerHelper.set('CreateTeam', TeamModel);
_identity_UserControllerHelper.set('GetCurrentUser', UserModel);


export const identity_UserControllerHelper = _identity_UserControllerHelper;

